export class NewPagePref {
  // orientation: string = 'horizontal';
  // textsize: string = '14';
  // textstyle: string = 'normal';
  orientation: string;
  textsize: number;
  textstyle: string;
  textcolor: string;
  urlstyle: string;

  youtubeCustomImageCMId: string;
}



// WEBPACK FOOTER //
// /app/src/app/core/models/new-page-prefs.ts